export default __webpack_public_path__ + "static/media/clientes-semanas.829c6601.png";